import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DatabaseConnect from "./components/DatabaseConnect";
import FieldSelector from "./components/FieldSelector";
import FlashcardViewer from "./components/FlashcardViewer";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Notion Flashcards</h1>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<DatabaseConnect />} />
            <Route path="/fields/:databaseId" element={<FieldSelector />} />
            <Route
              path="/flashcards/:databaseId"
              element={<FlashcardViewer />}
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
